import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 9" {...this.props}><path d="M24 0v4H0v1h24v4l6-4.5z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/widget/components/videos-list/nav-button/images/prev.svg